import { tempMeeApi } from '~/services/api';
import type {
  IResetPasswordApiPayload,
  TResetPasswordApiResponse,
} from '../types/ForgotPassword.api';

export const resetPassword = async (
  payload: IResetPasswordApiPayload,
): Promise<TResetPasswordApiResponse> => {
  const { data } = await tempMeeApi.patch<TResetPasswordApiResponse>(
    '/auth-service/users/password',
    payload,
  );
  return data;
};
